import React from 'react'

const AssociatedPages = ({ pages }) => {
  return (
    <section className="domain-details-modal__pages">
      <header className="domain-details-modal__pages__header">
        <h1 className="domain-details-modal__card-title">Associated Pages</h1>
      </header>
      <ol className="domain-details-modal__pages__list">
        <For each="page" index="index" of={pages}>
          <li className="domain-details-modal__pages__list-item" key={`pages-${index}`}>
            <a
              className="domain-details-modal__pages__list-link"
              href={page.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {page.url}
            </a>
          </li>
        </For>
      </ol>
    </section>
  )
}

export default AssociatedPages
